import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  inject,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ThemePipe } from '../../../core/pipes/theme.pipe';
import { NgStyle } from '@angular/common';
import { SplicedBackgroundComponent } from '../../spliced-background/spliced-background.component';
import { IconComponent } from '../../icon/icon.component';
import { ThemeService } from '../../../core/services/theme/theme.service';

@Component({
  selector: 'app-tab-button',
  templateUrl: './tab-button.component.html',
  styleUrls: ['./tab-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgStyle, ThemePipe, SplicedBackgroundComponent, IconComponent],
})
export class TabButtonComponent implements OnChanges {
  private themeService = inject(ThemeService);
  protected splicedBg = this.themeService.splicedBackgroundPlacement('tab-button', 'selected');

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isSelected']) {
      this.splicedBg = this.themeService.splicedBackgroundPlacement(
        'tab-button',
        this.isSelected ? 'selected' : 'unselected',
      );
    }
  }

  @Input({ required: true }) label!: string;
  @Input() isSelected = true;
  @Input() pendingCount: number | null = null;
  @Input() showDot = false;
  @Output() clickEvent = new EventEmitter<void>();

  get tabStyles(): [string, string][] {
    const key = `tab-${this.isSelected ? 'selected' : 'unselected'}`;
    return [
      ['type', `${key}-label`],
      ['text-color', `${key}-label`],
      ['border-radius', key],
      ['drop-and-inner-shadow', key],
      ['height', 'tab'],
    ];
  }

  onClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.clickEvent.emit();
  }
}
